import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiRefreshCw } from 'react-icons/fi';
import { APP_VERSION } from '../version';

// Mirrors the Android app's forced-update flow: once a new web build is
// live (client/public/version.json bumped alongside APP_VERSION on
// deploy), every open tab is blocked behind a full-screen overlay until
// it reloads and picks up the new bundle.
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

export default function UpdateGate() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const check = () => {
      fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d?.version && d.version !== APP_VERSION) setUpdateAvailable(true); })
        .catch(() => {});
    };
    check();
    const interval = setInterval(check, CHECK_INTERVAL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return (
    <AnimatePresence>
      {updateAvailable && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 10000 }}>
          <motion.div initial={{ scale: 0.95, y: 10 }} animate={{ scale: 1, y: 0 }}
            style={{ background: 'var(--bg-card)', borderRadius: 16, padding: '32px 28px', maxWidth: 360, width: '100%', textAlign: 'center', border: '1px solid var(--border)', boxShadow: 'var(--shadow-xl)' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(37,99,235,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <FiRefreshCw size={26} color="#2563eb" />
            </div>
            <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 800, color: 'var(--text-primary)' }}>A new version is available</h3>
            <p style={{ margin: '0 0 20px', fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
              Refresh to continue using Asset Logic.
            </p>
            <button onClick={() => window.location.reload()}
              style={{ padding: '11px 24px', borderRadius: 10, border: 'none', background: '#2563eb', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
              Refresh Now
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
